// extracted by mini-css-extract-plugin
export var black = "_4a-6";
export var brand = "_4a-1";
export var ddefault = "_4a-0";
export var error = "_4a-3";
export var gray = "_4a-2";
export var highContrast = "_4a-8";
export var outline = "_4a-7";
export var success = "_4a-5";
export var warning = "_4a-4";